import AvatarImage from 'ui/Element/Image/Avatar'
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getDocumentationIcon } from 'lib/util/icon'

const styles = () => ({
  icon: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays the icon of a documentation.
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellDashboardDocumentationIcon = (classes, props = {}) => {
  const { image, documentationType } = props
  const icon = getDocumentationIcon({ name: documentationType, nodeType: 'documentation' })

  const targetIcon = icon?.name || icon || 'document'

  const attachment = image?.attachment?.value?.name
    ? { ...image.attachment, key: image?.value?.attachmentId || image?.id || undefined, api: { ref: 'equipment' } }
    : { value: { name: '' } }

  return (
    <Grid className={classes.icon}>
      <AvatarImage
        shape={'circle'}
        attachment={attachment}
        fit={'contain'}
        fallbackIcon={{
          name: targetIcon,
          size: '1.5rem',
          color: 'text.regular',
          background: 'gray.960',
        }}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardDocumentationIcon, styles)
